import { lazy } from 'react';

export const Providers = lazy(() => import('./containers/common/Providers'));
export const ToastsContainer = lazy(() => import('./containers/common/ToastsContainer'));
export const SendbirdContainer = lazy(() => import('./containers/common/SendbirdContainer'));
export const UIStoreSync = lazy(() => import('./containers/common/UIStoreSync'));
export const FeatureToggler = lazy(() => import('./components/common/FeatureToggler'));
export const AnalyticsInitializer = lazy(() => import('./containers/common/AnalyticsInitializer'));
export const Content = lazy(() => import('./containers/common/Content'));
export const BrowserCommunicator = lazy(() => import('./containers/common/BrowserCommunicator'));
